import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The public services pages were removed before launch; the single
 * consultation is sold through the booking wizard. Kept as a permanent
 * redirect so indexed URLs do not 404.
 */
export const Route = createFileRoute("/_public/services")({
  beforeLoad: () => {
    throw redirect({ to: "/book", replace: true, statusCode: 301 });
  },
});
